import useResource from "../../../hooks/UseResource";
import * as PathologyService from "../../../services/PathologyService";

export default function usePathology(id) {
    return useResource(id, PathologyService.getPathology);
}
